import Vue from 'vue'
import directive from './directive' // directive
import App from './App.vue'
import ElementUI from 'element-ui'
import Plugins from "@/plugins"
import 'element-ui/lib/theme-chalk/index.css'
import 'xgplayer/dist/index.min.css'
import '@/assets/style/index.scss'
import router from './router'
import './assets/icons/index'

Vue.config.productionTip = false

Vue.use(directive)
Vue.use(ElementUI)
Vue.use(Plugins)

new Vue({
    router,
    render: h => h(App),
}).$mount('#app')
